import Store from "@/services/store";
import Router from "@/services/router";
import toolboxModule from "@/modules/toolbox/module";
import siteModule from "@/modules/site/module";

export default {
  init({ dispatch }) {
    console.info("System module initialized.");
    dispatch("initModule", toolboxModule);
    dispatch("initModule", siteModule);
  },
  initModule({ dispatch }, module) {
    Store.registerModule(module.name, module.store);
    Router.addRoutes(module.routes);
    dispatch(module.name + "/init", null, { root: true });
  },

  setStatus({ commit }, status) {
    commit("changeStatus", status);
  }
};
